import React from 'react';
import LazyLoad from '@nykaa/lazy-load';
import styled from 'App/styled';


const BOTTOM_MARGIN_FOR_LAZY_LOAD = 150;
const RIGHT_MARGIN_FOR_LAZY_LOAD = 100;
interface ShadeImageProps {
  shadeImage: string;
  variantName: string;
  additionalImageProps: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
  additionalClassForShade: string;
  isLazyLoad: boolean;
}
const PlaceHolder = styled.div`
  width: 100%;
  height: 32px;
  background: ${({ theme }) => theme.colors.surface30};
`;
const ShadeImgWrapper = styled.span`
  display: inline-block;
  overflow: hidden;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);
  width: 32px;
  height: 32px;
  position: relative;
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};

  img {
    width: 100%;
    height: 100%;
    border-radius: ${({ theme }) => theme.borders.radius20};
  }
  &: hover {
    cursor: pointer;
  }
  &.active {
    &:after {
      content: "";
      width: 7px;
      height: 15px;
      position: absolute;
      top: 5px;
      left: 12px;
      border: solid ${({ theme }) => theme.colors.white};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }

  &.oos {
    &::before {
      content: "";
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: ${({ theme }) => theme.borders.radius10};
      box-shadow: 0 0 4px 0 rgb(0 0 0 / 50%);
      width: 20px;
      height: 2px;
      transform: rotate(135deg);
      position: absolute;
      top: 15px;
      left: 6px;
    }
    &::after {
      content: "";
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: ${({ theme }) => theme.borders.radius10};
      box-shadow: 0 0 4px 0 rgb(0 0 0 / 50%);
      width: 20px;
      height: 2px;
      transform: rotate(45deg);
      position: absolute;
      top: 15px;
      left: 6px;
    }
  }
`;

const ShadeImage = (props: ShadeImageProps) => {
  const {
    shadeImage,
    variantName,
    additionalImageProps,
    additionalClassForShade,
  } = props;
  return (
    <ShadeImgWrapper className={additionalClassForShade}>
      <img
        src={`${shadeImage}?tr=w-50,h-50`}
        alt={`${variantName}-shade`}
        {...additionalImageProps}
      />
    </ShadeImgWrapper>
  );
};


const ShadePallet = (props: ShadeImageProps) => {
  const { isLazyLoad } = props;

  if (isLazyLoad) {
    return (
      <LazyLoad
          bottomMargin={BOTTOM_MARGIN_FOR_LAZY_LOAD}
          rightMargin={RIGHT_MARGIN_FOR_LAZY_LOAD}
          placeHolder={<PlaceHolder />}
          wrapperClassName="lazy-load-wrap"
        >
        <ShadeImage {...props} />
      </LazyLoad>
    );
  }

  return (
    <ShadeImage {...props} />
  );
};

export default ShadePallet;
